'use client';

import { V4GhostButton } from '@/components/landing/v4-shared';
import TalkToBriModalTrigger from '@/components/voice/TalkToBriModalTrigger';

/**
 * The final-CTA section's secondary "● Talk to Bri first" ghost button —
 * a client island so `CTASection` (a Server Component) stays server-rendered.
 * Sits beside the primary `V4CtaButton` "Get started" pill per the approved
 * mockup's final-CTA `cta-row` layout.
 */
export function FinalCtaVoiceButton() {
  return (
    <TalkToBriModalTrigger source="final_cta">
      {(open) => (
        <V4GhostButton onClick={open} variant="cyan" size="lg">
          <span aria-hidden="true">●</span> Talk to Bri first
        </V4GhostButton>
      )}
    </TalkToBriModalTrigger>
  );
}

export default FinalCtaVoiceButton;
